import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=0d43b4da&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports